export const userProfileRead = 'https://graph.microsoft.com/User.Read';
